import { Component } from '@angular/core';
import { ViewController, NavParams } from "ionic-angular";
@Component({
  selector: 'page-select_button',
  templateUrl: 'select_button.html',
})
export class Select_Button {
  testo: string;
  num:any;
  constructor(public viewCtrl: ViewController, public navpar:NavParams) {
    this.testo = this.navpar.get('testo');
    this.num = this.navpar.get('num');
    //num è un array di bottoni
    
  }

  response(res){
    this.viewCtrl.dismiss(res);
  }
}


// WEBPACK FOOTER //
// ./src/pages/select_button/select_button.ts